export default __webpack_public_path__ + "static/media/ic-changefund.5c1ca5b7.png";